
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import Image from 'global/Image';
import SEO from 'global/SEO';
import MainLayout from 'global/MainLayout';
import { withMaintenanceGuard } from 'global/Securities/utils/maintenance';
import EipoPage from 'features/eipo/components/eipo-detail';
import EipoOrder from 'features/eipo/components/eipo-order/';
import { showTradingModalWithAuth } from 'features/securities/AuthModal/utils';
import { Flex } from 'features/securities/styled';
import useAuthModalStore from 'features/securities/AuthModal/store';
import useTradingAccount from 'hooks/useTradingAccount';
import securitiesLocalStorage from 'utils/securitiesLocalStorage';

const EIpoProvider = dynamic(
  // @ts-ignore
  // eslint-disable-next-line
  () => import('stockbitipo/eipo-provider'),
  {
    ssr: false,
  },
);

const EIPO = () => {
  const router = useRouter();
  const showAuthModal = useAuthModalStore((state) => state.showModal);

  const [currentEmiten, setCurrentEmiten] = useState<string>('');
  const { isRealTrading, isVirtualTrading, tradingType } = useTradingAccount();
  const isLoggedInSekuritas =
    securitiesLocalStorage.getSecuritiesToken().securitiesAccessToken;

  const handleChangeRouter = (emiten: string) => {
    setCurrentEmiten(emiten);
    router.replace({
      query: { emiten },
    });
  };

  const checkSekuritasLogin = () => {
    if (!isLoggedInSekuritas) {
      withMaintenanceGuard(() => {
        showTradingModalWithAuth({});
      });
    }
  };

  useEffect(() => {
    const { emiten } = router.query;

    if (emiten !== undefined) {
      setCurrentEmiten(emiten.toString());
    }
    checkSekuritasLogin();
  }, []);

  return (
    <>
      <SEO title="Stockbit e-IPO" />
      <MainLayout isFlexibleWidth maxWidth={1036}>
        {isRealTrading && (
          <EIpoProvider isDark={false}>
            <EipoPage
              onClickListEmiten={handleChangeRouter}
              emiten={currentEmiten}
            />
            <EipoOrder emiten={currentEmiten} />
          </EIpoProvider>
        )}
        {(isVirtualTrading || !tradingType) && (
          <Flex
            align="center"
            justify="center"
            height="100vh"
            direction="column"
          >
            <div>
              <Image
                src="/illustration/eipo-login.svg"
                alt="Eipo Login Illustration"
                width="138"
                height="120"
              />
            </div>
            <p>
              <button
                onClick={() => showAuthModal()}
                style={{
                  color: '#0BA16B',
                  cursor: 'pointer',
                  border: 'none',
                  background: 'none',
                  display: 'inline',
                  fontWeight: 700,
                }}
                type="button"
              >
                Login
              </button>{' '}
              to view e-IPO
            </p>
          </Flex>
        )}
      </MainLayout>
    </>
  );
};

export default EIPO;
